import { type ReactNode, useContext } from 'react';

import { type TaxpayerRegistrationFieldConfiguration } from '../TaxpayerRequestEvaluation/types';

import { TaxpayerRegistrationContext } from './pages/request';

interface VisibleComponentProps {
  /**
   * Contenido que se renderizará cuando el campo esté habilitado.
   */
  children?: ReactNode;

  /**
   * Código del campo cuya configuración se desea consultar.
   */
  fieldCode: string;
}

/**
 * Renderiza sus hijos únicamente cuando el campo indicado
 * está registrado y habilitado dentro de MyContext.
 */
const VisibleComponent = ({ children, fieldCode }: VisibleComponentProps) => {
  // Lista de configuraciones de campos disponible en el contexto.
  const conf = useContext<TaxpayerRegistrationFieldConfiguration>(TaxpayerRegistrationContext);

  // No renderizar contenido si el campo no existe o está deshabilitado.
  if (!conf.fields.some((x) => x == fieldCode)) {
    return null;
  }

  return <>{children}</>;
};

export default VisibleComponent;
